import React, { memo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ContactButton = memo(({ mobile, onNavigate }) => {
  const { t } = useTranslation();
  const className = mobile
    ? "header--new__btn--mobile btn-n btn-n--black"
    : "header--new__btn--desktop btn-n btn-n--black";

  return (
    <Link
      className={className}
      to="/#contact-us"
      onClick={onNavigate}
    >
      <span className="btn-n__text">{t("nav.contactUs")}</span>
    </Link>
  );
});

export default ContactButton; 